module.exports = __webpack_public_path__ + "img/sms_api.8581ac8e.png";